// @flow
import * as React from 'react';
import styled from 'styled-components';
import { Metrics, Colors } from '../themes';

const Wrapper = styled.div`
  padding-left: ${Metrics.largeMargin}px;
  padding-right: ${Metrics.largeMargin}px;
  padding-top: ${Metrics.margin}px;
  padding-bottom: ${Metrics.margin}px;
  background-color: ${Colors.primaryBackground};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

function DialogFooter({ children }: { children?: React.Node }) {
  return (
    <Wrapper>
      {children}
    </Wrapper>
  );
}

export default DialogFooter;



// WEBPACK FOOTER //
// ./src/statsradio/components/DialogFooter.js